require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/angular-clipboard/angular-clipboard.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/angular-clipboard/angular-clipboard.js
// module id = 1523
// module chunks = 0